// Get the standard (non-DST) timezone offset for the user's location
export const getTimezone = (): number => {
  return new Date().getTimezoneOffset();
};
